/* author:莫兰;
 *  date:2020/12/14;
 *  explan:迁移时为快速迁移，决定采用原来的封装api方式；不再页面中写入
 * 仓库管理 相关api；
 */
import api from "./api.js";
let baseURL3 = process.env.VUE_APP_Url3; //郭鸿禧接口 8006；
let baseURL2 = process.env.VUE_APP_Url2; //郭雪峰接口 8000；
let baseURL1 = process.env.VUE_APP_Url1; //郭雪峰接口 8001；
let baseURL4 = "https://account1.huashengchongwu.com/"; //打印
let baseURL6 = process.env.VUE_APP_Url_baseData; //郭雪峰接口 8001；
// let baseURL5 = 'https://account.huashengchongwu.com/api/';
let baseURL5 = process.env.VUE_APP_upladHost;

export function shopTransferoutOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/transferout`, params);
} //门店调拨出库
export function shopLossoutOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/lossout`, params);
} //门店损耗出库
export function shopSaleoutoutOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/saleout`, params);
} //门店销售出库
export function shopOtherOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/otherout`, params);
} //其他出库
export function editShopOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/edit`, params);
} //编辑出库单
// export function getShopOutOrderList(params){return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/list`,params)}//出库列表
export function shopApproveOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/approve`, params);
} //出库审核
export function getOutOrderDl(params) {
  return api.get(`${baseURL3}api/Warehouse/OutOrder/detail`, params);
} //出库详情
export function approveSendOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/approve/send`, params);
} //申请进入审批流程
export function shopScrapOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/scrap`, params);
} //出库审核
export function shopUserOutOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/OutOrder/shop/SelfUse`, params);
} //门店自用出库
export function getshopList(params) {
  return api.get(`${baseURL2}api/CompanyInfo/shoplist`, params);
} //获取仓库列表

export function getGoodsCustomCodeInfo(params) {
  return api.get(`${baseURL3}api/Goods/tracksimple`, params);
} //根据码读取条码内置信息
// api/Goods/code/info
export function getGoodsCodeInfo(params) {
  return api.get(`${baseURL3}api/Goods/code/simple/info`, params);
} //根据码读取条码内置信息(新)
// 以下为条码页面所需
export function getGoodsCustomCodeList(params) {
  return api.post(`${baseURL3}api/Goods/CustomCode/List`, params);
} //条码列表

// export function getGoodsCustomCodeDL(params){return api.get(`${baseURL3}api/Goods/track`,params)}
export function print(params) {
  return api.post(`${baseURL4}api/media/do_print`, params);
} //打印条码
export function shopPrint(params) {
  return api.post(`${baseURL4}api/media/shop_print`, params);
} //门店间隔条码打印
export function editCustomCood(params) {
  return api.post(`${baseURL3}api/Goods/update/codeinfo`, params);
}
export function updateLostStatus(params) {
  return api.post(`${baseURL3}api/Goods/update/loststatus`, params);
} //丢失
export function updateLostreCoveryStatus(params) {
  return api.post(`${baseURL3}api/Goods/update/lostrecoverystatus`, params);
} //还原
export function codeinfoSplit(params) {
  return api.post(`${baseURL1}api/Goods/codeinfo/split`, params);
} //条码拆分
// 上传单图片

// export function uploadImg (params) { return api.post(`${baseURL5}media/upload_img`, params)}
export function uploadImg(params) {
  return api.post(`${baseURL5}/api/media/oss/upload?dir=petImg`, params);
}
export function uploadMemberImg(params) {
  return api.post(`${baseURL5}/api/media/oss/upload?dir=memberImg`, params);
}
// 入库编辑api/Warehouse/InOrder/shop/edit
export function setShopInOrder(params) {
  return api.post(`${baseURL3}api/In/shop/transfer/Examine`, params);
}
export function getShopInOrderDl(params) {
  return api.get(`${baseURL3}api/Warehouse/InOrder/detail`, params);
}
export function approveSendInOrder(params) {
  return api.post(`${baseURL3}api/Warehouse/InOrder/approve/send/post`, params);
}
// export function approveShopInOrder (params) { return api.post(`${baseURL3}api/Warehouse/InOrder/shop/approve`, params) }
// export function getTrackSimple (params) { return api.get(`${baseURL3}api/Goods/track`, params) }
export function getTrackSimple(params) {
  return api.get(`${baseURL6}/api/product/goods/from/code`, params);
}
